import { UserData } from '@e3dc-react/shell/Types'
import { Installation } from 'src/Libs/installations/models/installation.model'
import { isOwnerOrCompany } from 'src/Libs/installations/utils'

/**
 * Return true if the installation is located in germany and user is owner of the installation
 */
export const hasAccessToDirectMarketing = (installation?: Installation, userData?: UserData): boolean => {
  if (installation?.countryCode !== 'DEU') return false

  return isOwnerOrCompany(installation, userData)
}
